import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import {CommonService} from '../services/common.service';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { RouterModule } from '@angular/router';


import {  TagprescriptionComponent } from './tagprescription/tagprescription.component'
import { Ng2UploaderModule } from 'ng2-uploader';
import { MainmenuComponent } from './mainmenu/mainmenu.component';
import { AppmobilesidemenuComponent } from './appmobilesidemenu/appmobilesidemenu.component';
import { NgxLoadingModule } from 'ngx-loading';
import { MatButtonModule, MatSnackBarModule, MatDialogModule, MatIconModule } from '@angular/material';
import { CartService } from '../services/cart.service';
import { MobilefilterpopupComponent } from './mobilefilterpopup/mobilefilterpopup.component';
import { FilterModule } from '../filter/filter.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    NgxLoadingModule,
    RouterModule,
    MatButtonModule,MatSnackBarModule,MatDialogModule,
    Ng2UploaderModule,
    MatIconModule,
    FilterModule
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    TagprescriptionComponent,
    MainmenuComponent,
    AppmobilesidemenuComponent,
    MobilefilterpopupComponent
  ],
  providers: [
    CommonService,
    CartService,
  ],
  entryComponents: [
    TagprescriptionComponent, MobilefilterpopupComponent
  ],
  exports: [ HeaderComponent,
    FooterComponent, TagprescriptionComponent, MainmenuComponent, AppmobilesidemenuComponent,
  ],
})
export class SharedModule { }
